import { Component, Input } from '@angular/core';
import { DetailField } from '../../_models/components/detail-field';

@Component({
  selector: 'share-entity-detail-panel',
  templateUrl: './share-entity-detail-panel.component.html'
})
export class ShareEntityDetailPanelComponent {
  @Input() fields: DetailField[] = [];
}
